// תצוגת התקדמות/תוצאה של עבודה עם פירוט לכל וריאציה (מבנה גמיש — לפי מה שהעבודה מדווחת).
import type { Job } from '../../api';
import { JobBadge } from '../ui';

interface Item { variantId?: string; id?: string; status?: string; ok?: boolean; error?: string | null; revision?: number; message?: string; width?: number; height?: number }

function listOf(x: any): Item[] | null {
  if (!x) return null;
  if (Array.isArray(x)) return x;
  for (const k of ['items', 'variants', 'results', 'perVariant', 'sizes']) if (Array.isArray(x[k])) return x[k];
  if (typeof x === 'object' && x.byVariant && typeof x.byVariant === 'object') return Object.entries(x.byVariant).map(([variantId, v]: any) => ({ variantId, ...v }));
  return null;
}

export default function JobProgress({ job, nameOf }: { job: Job; nameOf: (variantId: string) => string }) {
  const items = listOf(job.result) ?? listOf(job.progress);
  const p: any = job.progress;
  return (
    <div className="stack" aria-live="polite">
      <div className="row">
        <JobBadge status={job.status} />
        {p && typeof p === 'object' && (p.done != null || p.total != null) && <span className="small mono">{p.done ?? 0}/{p.total ?? '?'}</span>}
        {p && typeof p === 'object' && p.message && <span className="small">{p.message}</span>}
        {typeof p === 'number' && <span className="small mono">{Math.round(p * (p <= 1 ? 100 : 1))}%</span>}
      </div>
      {job.error && <div className="alert err small">{job.error}</div>}
      {items && items.length > 0 && (
        <table className="table">
          <thead><tr><th>גודל</th><th>מצב</th><th>פרטים</th></tr></thead>
          <tbody>
            {items.map((it, i) => {
              const vid = it.variantId ?? it.id ?? '';
              const st = it.status ?? (it.ok === true ? 'succeeded' : it.ok === false || it.error ? 'failed' : 'running');
              return (
                <tr key={vid || i}>
                  <td>{vid ? nameOf(vid) : it.width ? `${it.width}×${it.height}` : i + 1}</td>
                  <td><JobBadge status={st === 'ok' || st === 'done' ? 'succeeded' : st === 'error' ? 'failed' : st} /></td>
                  <td className="small">{it.error ? <span style={{ color: 'var(--danger)' }}>{it.error}</span> : it.revision ? <>גרסה <span className="mono">{it.revision}</span></> : it.message ?? ''}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}
